<template>
  <div v-if="$store.getters.currentProjectName" class="project-top df" v-bind:class="{'project-top-extra': !$store.getters.emailVerified}">
    <div class="tour-shadow" />
    <span class="df fdr aic posrel grey-box" data-v-step="0">
      <p v-on:click="editProjectName()" v-if="!editingProjectName" class="project-name nexa-font-bold"  >
        {{ $store.getters.currentProjectName }}
      </p>
      <input
        v-on:input="test($event.target.value)"
        v-on:blur="stopEditingProjectName($event.target.value)"
        v-on:change="stopEditingProjectName($event.target.value)"
        v-else
        v-bind:value="$store.getters.currentProjectName"
        type="text"
        class="edit-project-name nexa-font-bold"
        :disabled="!editable"
      >
      <span class="gear-wrapper" v-if="!editingProjectName && !$store.getters.tokenData.email">
        <img v-if="!$store.getters.tokenData.email" v-on:click="openProjectMenu($event)" src="/images/Gear-Icon.png" class="project-menu-dropdown curp" alt="">
      </span>

      <div class="box project-menu mini-menu" v-if="showProjectMenu == true" v-closable="{
        handler: 'closeProjectMenu'
      }">
        <span v-on:click="changeProjectStatus('approved')" v-if="enableAction('approved')">
          <p>
            <img src="/images/mini-menu-icons/Thumbs-Up-Icon.png" alt="">
            Approve Project
          </p>
        </span>
        <span v-on:click="changeProjectStatus('rejected')" v-if="enableAction('rejected')">
          <p>
            <img src="/images/mini-menu-icons/Thumbs-Down-Icon.png" alt="">
            Reject Project
          </p>
        </span>
        <hr class="hr1">
        <span v-on:click="changeProjectStatus('completed')" v-if="enableAction('completed')">
          <p>
            <img src="/images/mini-menu-icons/Project-Complete-Icon.png" alt="">
            Mark Project As Complete
          </p>
        </span>
        <span v-on:click="changeProjectStatus('closed')" v-if="enableAction('closed')">
          <p>
            <img src="/images/mini-menu-icons/Project-Closed-Icon.png" alt="">
            Mark Project As Closed
          </p>
        </span>
        <span v-on:click="saveAsTemplate()">
          <p>
            <img src="/images/mini-menu-icons/Template-Icon.png" alt="">
            Save As Template
          </p>
        </span>
        <hr class="hr1">
        <span className="project-versioning-link" v-on:click="triggerHelp()">
          <p>
            <img src="" alt="">
            Start project tour
          </p>
        </span>
      </div>
    </span>
    <div class="project-basic-wpr">
      <span class="project-basic df fdr" v-bind:class="{'pen': $store.getters.tokenData.email}">

        <span class="grey-box clickable" data-v-step="1" v-if="isAdmin">
          <span class="grey-box-top" v-on:click="test()">
            <p class="gg-font grey-box-label-1">
              Blended Rate
            </p>
          </span>
          <span class="grey-box-info gg-font df" v-on:click="startEditingRateContingency()" >
            ${{ $store.getters.currentProjectRate }} <span class="gg-font now">/ h</span>
          </span>

        </span>
        <span class="grey-box clickable mb-10" v-if="isAdmin">
          <span class="grey-box-top">
            <p class="gg-font grey-box-label-1">
              Hourly Cost
            </p>
          </span>
          <span class="grey-box-info gg-font df" v-on:click="startEditingRateContingency()">
            ${{ $store.getters.currentProjectContingency }} <span class="gg-font now">/ h</span>
          </span>
        </span>
        <span class="top-divider" v-if="isAdmin">
        </span>
        <span class="grey-box override-box fdr aic curp new-override-button mb-10" v-on:click="addOverride()" v-if="isAdmin" data-v-step="2">
          <span v-if="!$store.getters.tokenData.email" class="add-override">
            <img src="/images/plus.png" alt="" class="curp">
            <div v-if="this.editingOverride !== false" class="box add-new-override" v-on:click="stopProp($event)">
              <p>Edit Override</p>
              <input type="text" v-model="editingOverrideName" class="input2" placeholder="Override Name" />
              <span class="df fdr override-images">
                <img  v-if="editingOverrideType == 'percent'"
                      src="/images/Percentage-Blue.svg" alt="">
                <img  v-else src="/images/Percentage-Grey.svg"
                      v-on:click="setEditingOverrideType('percent')" alt="">
                <img  v-if="editingOverrideType == 'fixed'"
                      src="/images/FixedPrice-Blue.svg" alt="">
                <img  v-else src="/images/Price-Grey.svg"
                      v-on:click="setEditingOverrideType('fixed')" alt="">
              </span>
              <span class="input-wrap-fixed-percent">
                <input v-model="editingOverrideValue" type="number" class="input2"/>
                <p v-if="editingOverrideType == 'fixed'" class="fixed-percent add-override-fixed">$</p>
                <p v-else-if="editingOverrideType == 'percent'" class="fixed-percent add-override-percent">%</p>
              </span>
              <button v-on:click="saveEditingOverride()" class="button-form button-form-active">
                Save
              </button>
              <span class="close close2" v-on:click="stopAddingOverride($event)">
                Cancel
              </span>
            </div>
            <div v-if="this.addingOverride == true" class="box add-new-override">
              <p>Add New Override</p>
              <input type="text" v-model="addingOverrideName" class="input2" placeholder="Override Name" />
              <span class="df fdr override-images">
                <img  v-if="addingOverrideType == 'percent'"
                      src="/images/Percentage-Blue.svg" alt="">
                <img  v-else src="/images/Percentage-Grey.svg"
                      v-on:click="setOverrideType('percent')" alt="">
                <img  v-if="addingOverrideType == 'fixed'"
                      src="/images/FixedPrice-Blue.svg" alt="">
                <img  v-else src="/images/Price-Grey.svg"
                      v-on:click="setOverrideType('fixed')" alt="">
              </span>
              <span class="input-wrap-fixed-percent">
                <input v-model="addingOverrideValue" type="number" class="input2"/>
                <p v-if="addingOverrideType == 'fixed'" class="fixed-percent add-override-fixed">$</p>
                <p v-else-if="addingOverrideType == 'percent'" class="fixed-percent add-override-percent">%</p>
              </span>
              <button v-on:click="addNewOverride()" class="button-form button-form-active" :disabled="addingOverrideValue == 0 || addingOverrideName.trim() == '' ? true : false">
                Add
              </button>
              <span class="close close2" v-on:click="stopAddingOverride($event)">
                Cancel
              </span>
            </div>
          </span>
          <p class="add-new-override-title gg-font curp">
            Add New Override
          </p>
        </span>
        <span class="grey-box clickable mb-10 overrides-item"
              v-for="(item, key) in $store.getters.currentProjectOverrides"
              v-on:click="editOverride(key)"
              v-bind:key="key">
          <span class="grey-box-top">
            <p class="gg-font grey-box-label-1">
              {{ item.name || '&nbsp;' }}
            </p>
          </span>
          <span class="grey-box-info custom-override gg-font">
            <span class="sign-dollar">{{ item.type !== 'percent' ? '$' : '' }}</span>
            {{ item.type == 'fixed' ? dollarAmount(item.value) : item.value }}
            <span class="sign-percent">{{ item.type == 'percent' ? ' %' : '' }}</span>
            <span v-if="!$store.getters.tokenData.email" class="close-custom-override" v-on:click="deleteCustomOverride($event, key)">
              <img src="/images/plus.svg" alt="">
            </span>
          </span>
        </span>
        <span class="df fdr top-right">
          <span v-if="totalHours == '0.0'" class="grey-box no-hours posrel">
            <span class="grey-box-top">
              <p class="gg-font grey-box-label-1">
                Total Hours
              </p>
            </span>
            <span class="grey-box-info no-hours-smaller gg-font posrel">
              None
              <span class="tooltip tooltip-no-hours">
                <span class="posrel">
                  <img class="icon" src="/images/Help.svg" alt="">
                  <span class="box tooltip-box tooltip-top-right df fdc">
                    <p class="tooltip-title">
                      Your project only has fixed prices
                    </p>
                    <p class="tooltip-text">
                      Because you don't have any people on your project, you haven't estimated any hours. Add at least one hourly resource to begin adding hours to your project.
                    </p>
                    <span class="tooltip-link">
                      <p @click="addHourlyColumn()">
                        Create an hourly resource
                      </p>
                      <img class="icon" src="/images/Hours-Blue.svg" alt="">
                    </span>
                    <span class="tooltip-link">
                      <p @click="addPercentColumn()">
                        Create a variable resource
                      </p>
                      <img class="icon" src="/images/Percentage-Blue.svg" alt="">
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
          <span v-else class="grey-box">
            <span class="grey-box-top">
              <p class="gg-font grey-box-label-1">
                Total Hours
              </p>
            </span>
            <span class="grey-box-info gg-font">
              {{ totalHours }}
            </span>
          </span>
          <span class="grey-box" id="total-sum" data-v-step="6">
            <span class="grey-box-top">
              <p class="gg-font grey-box-label-1">
                Total Price
              </p>
            </span>
            <span class="grey-box-info gg-font" id="flashing-total">
              {{ totalPrice }}
            </span>
          </span>
        </span>
      </span>
    </div>
    <div v-if="editingRateContingency || showSaveAsTemplate" class="popup-backer" v-on:click="hidePopups()"></div>
    <div v-if="editingRateContingency" v-closable="{
    handler: 'onCloseProjectRateEditing'
  }" class="box editing-rate-contingency df fdc jcc aic">
      <h2>Edit Project Price</h2>
      <div class="form-row df fdr">
        <span class="input-wrapper df fdc posrel">
          <p class="label">Hourly Rate</p>
          <input tabindex="100" v-on:input="setRate($event.target.value)" v-bind:value="projectRate"  class="input1" type="number">
          <p class="dollar-caption">$</p>
        </span>
        <span class="input-wrapper df fdc posrel">
          <p class="label">Hourly Cost</p>
          <input tabindex="101" v-on:input="setContingency($event.target.value)" v-bind:value="projectContingency" class="input1" type="number">
          <p class="dollar-caption">$</p>
        </span>
      </div>
      <div class="form-row df fdr button-row">
        <span class="input-wrapper df fdc w100">
          <button tabindex="102" v-on:click="updateProjectRateContingency()" class="button-form button-form-active">
            Update
          </button>
        </span>
        <span class="input-wrapper df fdc">
        </span>
      </div>
      <div tabindex="103" v-on:click="stopEditingRateContingency()" v-on:keydown.enter="stopEditingRateContingency()" v-on:keydown.space="stopEditingRateContingency()" class="close">
        Close
      </div>
    </div>

    <div v-if="showSaveAsTemplate" class="box editing-rate-contingency df fdc jcc aic">
      <h2>Save As Template</h2>
      <div class="form-row df fdr">
        <span class="input-wrapper df fdc posrel">
          <p class="label">Name</p>
          <input class="input1" type="text" v-model="newTemplateName">
        </span>
      </div>
      <div class="form-row df fdr button-row">
        <span class="input-wrapper df fdc w100">
          <button v-on:click="saveNewTemplate()" class="button-form button-form-active">
            Save
          </button>
        </span>
        <span class="input-wrapper df fdc">
        </span>
      </div>
      <div v-on:click="hidePopups()" class="close">
        Close
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex';
import ProjectUtil from '../../util/project';

export default {
  // import Login from '../components/Login'

  name: 'ProjectTop',
  data () {
    return {
      newTemplateName: '',
      showVersioningMenu: false,
      showCreateNewVersion: false,
      showSaveAsTemplate: false,
      showProjectMenu: false,
      selectedPriceRange: 'mid',
      addingOverride: false,
      editingOverride: false,
      editingOverrideName: null,
      editingOverrideType: null,
      editingOverrideValue: null,
      addingOverrideName: '',
      addingOverrideType: 'fixed', // or 'percent'
      addingOverrideValue: 0,
      editingRateContingency: false,
      editingProjectName: false,
      projectContingency: this.$store.getters.currentProjectContingency,
      projectRate: this.$store.getters.currentProjectRate,
      loaded: false
    }
  },
  props: [],
  components: {

  },
  methods: {
    enableAction(action) {
      if (this.userRole === 'customer') {
        return ['approved', 'rejected'].includes(action)
      }
      if (this.userRole === 'vendor') {
        return false
      }
      return true
    },
    stopProp (e) {
      e && e.stopPropagation()
    },
    triggerHelp() {
        this.$parent.startTour();
    },
    addHourlyColumn () {
      var data = {
        phases: this.$store.getters.currentProjectPhases,
        projectid: this.$route.params.projectid
      }
      console.log('addHourlyColumn')
      this.$store.dispatch('addHourlyColumn', data).then(() => {
        console.log('after addHourlyColumn')
      })
    },
    addPercentColumn () {
      var data = {
        phases: this.$store.getters.currentProjectPhases,
        projectid: this.$route.params.projectid
      }
      console.log('addPercentColumn')
      this.$store.dispatch('addPercentColumn', data).then(() => {
        console.log('after addPercentColumn')
      })
    },
    toggleVersioningMenu () {
      this.showVersioningMenu = !this.showVersioningMenu
    },
    editOverride (index) {
      this.editingOverride = index
      this.editingOverrideName = this.$store.getters.currentProjectOverrides[index].name
      this.editingOverrideType = this.$store.getters.currentProjectOverrides[index].type
      this.editingOverrideValue = this.$store.getters.currentProjectOverrides[index].value
      this.$store.dispatch('showGlobalPopup', {show: true}).then(() => {
        console.log('after showGlobalPopup')
      })
      console.log('edit override', index, this.$store.getters.currentProjectOverrides[index])
    },

    saveEditingOverride () {
      console.log('save override')
      if (!this.editingOverrideValue && (this.editingOverrideValue !== 0)) {
        return false
      }

      var data = {
        projectid: this.$route.params.projectid,
        existingOverridesList: this.$store.getters.currentProjectOverrides,
        index: this.editingOverride,
        name: this.editingOverrideName,
        type: this.editingOverrideType,
        value: this.editingOverrideValue
      }

      console.log('2')
      var _this = this
      _this.$store.dispatch('editOverride', data).then(() => {
        console.log('after saveOverride')
        _this.$store.dispatch('showGlobalPopup', {show: false}).then(() => {
          console.log('after showGlobalPopup')
        })
        setTimeout(() => {_this.resetNewOverride()}, 1)
      })
    },
    addOverride () {
      var _this = this
      if (_this.$store.getters.currentProjectOverrides.length < 5) {
        _this.addingOverride = true
        _this.$store.dispatch('showGlobalPopup', {show: true}).then(() => {
          console.log('after showGlobalPopup')
        })
      }
    },
    addNewOverride () {
      var _this = this
      if (!_this.addingOverrideValue && (_this.addingOverrideValue !== 0)) {
        return false
      }
      var data = {
        existingOverridesList: this.$store.getters.currentProjectOverrides,
        projectid: this.$route.params.projectid,
        name: this.addingOverrideName,
        type: this.addingOverrideType,
        value: this.addingOverrideValue
      }
      this.$store.dispatch('addNewOverride', data).then(() => {
        console.log('after addNewOverride')
        setTimeout(() => {_this.resetNewOverride()}, 1)
      })
    },
    deleteCustomOverride (event, key) {
      var _this = this
      event.stopPropagation();
      var data = {
        projectid: _this.$route.params.projectid,
        key: key
      }
      _this.$store.dispatch('deleteCustomOverride', data).then(() => {
        console.log('after deleteCustomOverride')
      })
    },
    stopAddingOverride (e) {
      e ? e.stopPropagation() : null
      this.editingOverride = false
      this.editingOverrideName = null
      this.editingOverrideType = null
      this.editingOverrideValue = null

      this.$store.dispatch('showGlobalPopup', {show: false}).then(() => {
        console.log('after showGlobalPopup')
      })

      this.resetNewOverride()
    },
    resetNewOverride () {
      this.addingOverride = false
      this.addingOverrideName = ''
      this.addingOverrideType = 'fixed'
      this.addingOverrideValue = 0

      this.editingOverride = false
      this.editingOverrideName = null
      this.editingOverrideType = null
      this.editingOverrideValue = null

      this.$store.dispatch('showGlobalPopup', {show: false}).then(() => {
        console.log('after showGlobalPopup')
      })
    },
    createNewVersion () {
      this.showCreateNewVersion = true
    },
    saveNewTemplate () {
      console.log('this first', this.$store.getters.myProjectListWithDetails, this.$store.getters.myProjectListWithDetailsFull, this.$route.params.projectid)

      var data = {
        projectDetails: this.$store.getters.myProjectListWithDetails[this.$route.params.projectid],
        projectDetailsFull: this.$store.getters.myProjectListWithDetailsFull[this.$route.params.projectid],
        projectid: this.$route.params.projectid,
        name: this.newTemplateName,
        company: this.$store.getters.myCompany
      }

      this.$store.dispatch('saveNewTemplate', data).then(() => {
        console.log('after saveNewTemplate')
        this.hidePopups()
      })
    },
    revertToVersion (key, project, projectFull, versions) {
      var data = {
        versionKey: key,
        projectid: this.$route.params.projectid,
        project: project,
        projectFull: projectFull,
        versions: versions
      }
      this.$store.dispatch('revertToVersion', data).then(() => {
        console.log('after revertToVersion')
        this.hidePopups()
      })
    },
    saveNewVersion () {
      console.log('this first', this.$store.getters.myProjectListWithDetails, this.$store.getters.myProjectListWithDetailsFull, this.$route.params.projectid)

      var data = {
        projectDetails: this.$store.getters.myProjectListWithDetails[this.$route.params.projectid],
        projectDetailsFull: this.$store.getters.myProjectListWithDetailsFull[this.$route.params.projectid],
        projectid: this.$route.params.projectid
      }

      this.$store.dispatch('saveNewVersion', data).then(() => {
        console.log('after saveNewVersion')
        this.hidePopups()
      })
    },
    saveAsTemplate () {
      this.showProjectMenu = false
      this.showSaveAsTemplate = true
      this.$store.dispatch('showGlobalPopup', {show: true}).then(() => {
        console.log('after showGlobalPopup')
      })
    },
    hidePopups () {
      this.showCreateNewVersion = false
      this.showSaveAsTemplate = false
      this.editingRateContingency = false
      this.showProjectMenu = false
      this.showVersioningMenu = false
      this.newTemplateName = ''
      this.$store.dispatch('showGlobalPopup', {show: false}).then(() => {
        console.log('after showGlobalPopup')
      })
    },
    changeProjectStatus (status) {
      var data = {
        projectid: this.$route.params.projectid,
        status: status
      }
      console.log('changeProjectStatus')
      this.$store.dispatch('changeProjectStatus', data).then(() => {
        console.log('after changeProjectStatus')
        this.closeProjectMenu()
      })
    },
    openProjectMenu (event) {
      event.stopPropagation()
      event.preventDefault()
      console.log('openProjectMenu')
      console.log(this.$store.getters.myProjectListWithDetailsFull[this.$route.params.projectid].versions)
      this.showProjectMenu = !this.showProjectMenu

      this.$store.dispatch('showGlobalPopup', {show: true}).then(() => {
        console.log('after showGlobalPopup')
      })
    },
    closeProjectMenu () {
      this.hidePopups()
    },
    formattedDate (d) {
      var date = new Date(d)
      var dateString = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
      return dateString
    },
    nowDate() {
      return new Date()
    },
    dollarAmount (amount) {
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2
      })

      return formatter.format(amount) // "$1,000.00"
    },

    onCloseProjectRateEditing () {
      this.hidePopups()
    },
    editProjectName () {
      if (!this.editable) {
        return false
      }

      this.editingProjectName = true

      this.$store.dispatch('showGlobalPopup', {show: true}).then(() => {
        console.log('after showGlobalPopup')
      })
    },
    test(v){
      console.log("yoyoyoyoyoyoyoyoyoyoy", v)
      if(v.length === 0) return false
      return true
      this.$forceUpdate()
    },
    stopEditingProjectName (v) {
      if(v.length === 0) return this.$forceUpdate()
      var data = {
        projectid: this.$route.params.projectid,
        name: v
      }
      this.$store.dispatch('updateProjectName', data).then(() => {
        console.log('after updateProjectName')
      })

      this.$store.dispatch('showGlobalPopup', {show: false}).then(() => {
        console.log('after showGlobalPopup')
      })

      console.log('v', v)
      console.warn("hello world")
      this.editingProjectName = false

    },
    setRate (v) {
      this.projectRate = v
    },
    setOverrideType (type) {
      this.addingOverrideType = type
    },
    setEditingOverrideType (type) {
      this.editingOverrideType = type
    },
    setContingency (v) {
      this.projectContingency = v
    },
    startEditingRateContingency () {
      this.projectContingency = this.$store.getters.currentProjectContingency
      this.projectRate = this.$store.getters.currentProjectRate
      setTimeout(() => {
        this.editingRateContingency = true
        this.$store.dispatch('showGlobalPopup', {show: true}).then(() => {
          console.log('after showGlobalPopup')
        })
      }, 50)
    },
    stopEditingRateContingency () {
      this.editingRateContingency = false
      this.$store.dispatch('showGlobalPopup', {show: false}).then(() => {
        console.log('after showGlobalPopup')
      })
    },
    updateProjectRateContingency () {
      var data = {
        projectid: this.$route.params.projectid,
        rate: this.projectRate,
        contingency: this.projectContingency
      }
      this.$store.dispatch('updateProjectRateContingency', data).then(() => {
        console.log('after updateProjectRateContingency')
        this.stopEditingRateContingency()
      })
    }
  },
  computed: {
    ...mapGetters(['userRole']),
    isAdmin() {
      return ['admin', 'collaborator'].includes(this.userRole)
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    },
    totalPrice () {
      var rate = this.$store.getters.currentProjectRate
      var modules = this.$store.getters.currentProjectModules
      var columns = this.$store.getters.currentProjectModuleColumns
      var overrides = this.$store.getters.currentProjectOverrides
      const total = ProjectUtil.totalPriceWithOverrides(modules, columns, rate, overrides)
      return ProjectUtil.priceFormatterValue(total)
    },
    totalHours () {
      var modules = this.$store.getters.currentProjectModules
      var columns = this.$store.getters.currentProjectModuleColumns
      return ProjectUtil.totalHours(modules, columns)
    }
  },
  created () {
    document.onkeydown = checkKey;
    var _this = this
    function checkKey(e) {
      console.log('enter', e.keyCode == '13')
        e = e || window.event;
        if (e.keyCode == '13' && _this.editingRateContingency) {
        console.log('enter2')
            e.preventDefault()
            _this.updateProjectRateContingency()
        }
    }
  }
}

</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";

h2 {
  color: #000000;
  font-size: 24px;
  font-weight: 300;
  line-height: 43px;
  margin-bottom: 30px;
}

.project-top {
  padding: 20px 50px 10px;
  background-color: white;
  width: 100%;

  // span
  & > span {
    // margin-right: 60px;
    &:last-child {
      margin-right: 0;
    }
  }

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    flex-wrap: wrap;
    height: auto;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;

    // f1
    .f1 {display: none;}
  }
}

//
// Project Name
//
.project-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 230px;
  width: 230px;

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    max-width: unset;
    width: 100%;
  }
}

.project-name, .edit-project-name {
  color: #050505;
  font-size: 24px;
  line-height: 27px;
}

.edit-project-name {
  width: 270px;
  background-color: transparent;
  padding: $greyBoxPadding;
  padding-left: calc(#{$greyBoxPadding} * 2);
  border: 0;
  color: $almostBlack;
  border-bottom: 2px solid $almostBlack;

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    width: 100%;
  }
}

.grey-box {
  height: 45px;
  padding: $greyBoxPadding;
  border-radius: $greyBoxRadius;
  background-color: #F5F5F5;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;

  & > .gear-wrapper {
    width: 40px;
    height: 100%;
    background-color: $greyBoxGrey2;
    border-top-right-radius: $greyBoxRadius;
    border-bottom-right-radius: $greyBoxRadius;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -ms-align-items: center;
    align-items: center;
    justify-content: center;

    img {
      width: 16px;
      height: 16px;
    }
  }
}

.project-basic-wpr {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
}

//
// Grey Box Fdr
//
.grey-box.fdr {
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
  padding: 0;
  width: 270px;
  justify-content: space-between;
  margin-right: 60px;

  // p
  & > p {
    padding: $greyBoxPadding;
    padding-left: calc(#{$greyBoxPadding} * 2);
    color: $almostBlack;
    font-size: 24px;
  }

  // add new override title
  .add-new-override-title {
    font-size: 12px;
    font-weight: 500;
    color: $grey;
  }

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 10px;
  }
}

.grey-box.override-box {
  width: unset;
  padding: $greyBoxPadding;
  padding-left: calc(#{$greyBoxPadding} * 2);
  padding-right: calc(#{$greyBoxPadding} * 2);
  margin-right: 10px;
}

.grey-box-top {;
  color: #4F4F4F;
  font-size: 10px;
  letter-spacing: 0.36px;
  white-space: nowrap;

  p {
    font-weight: 600;
  }
}
.grey-box-info {
  color: #050505;
  font-size: 24px;
  line-height: 24px;

  & > span {
    color: #848484;
  }
}
.sign-dollar {
  margin-right: 3px;
}
.sign-percent {
  margin-left: 3px;
}
.grey-box-info.custom-override {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.grey-box-label-1 {
  line-height: 12px;
}

.mb-10 {
  margin-bottom: 10px;
}

//
// Project Basic
//
.project-basic {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  // span
  & > span {
    margin-right: 20px;
    &:last-of-type {
      margin-right: 0;
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    flex-wrap: wrap;
    > span {
      width: calc(50% - 5px);
      margin-right: 0px;
      &:first-child {margin-right: 10px;}
    }
    .top-divider {display: none;}
    .override-box {display: none;}
  }
}


.popup-backer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  z-index: 150;
  min-height: 100vh;
}
.editing-rate-contingency {
  z-index: 155;
  padding: 50px;
  position: relative;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.form-row {
  width: 100%;
}
.w100 {
  width: 100%;
}
.button-row {
  margin-top: 25px;
}
.label {
  margin-bottom: 6px;
}
.close {
  position: absolute;
  left: 18px;
  top: 14px;
  color: #5558FF;
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
  text-transform: uppercase;
  cursor: pointer;

  &:focus {
    text-decoration: underline;
    color: $primaryColorDarker;
  }
}
.close2 {
  left: unset;
  right: 18px;
}
.add-override {
  height: 22px;
  width: 22px;
  background-color: $highlightColor;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.26);
  border-radius: 50%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  position: relative;

  & > img {
    /*height: 17px;*/
    /*width: 17px;*/
    /*transform: translate(1px, 1px);*/
  }
}
.project-tabs {
  // z-index: 1;
  // height: 175px;
  // width: 1280px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.13);
  // z-index: 1000;
}
.add-new-override {
  z-index: 111;
  width: 100%;
  min-width: 240px;
  padding: 35px 25px 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  color: black;
  transform: translate(-2px, -3px);
  & > p {
    font-size: 18px;
    font-weight: 600;
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
  }
  .input2 {
    margin-bottom: 15px;
  }
}
.override-images {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  img {
    height: 30px;
    min-height: 30px;
    width: 30px;
    min-width: 30px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
}

.input-wrap-fixed-percent {
  position: relative;
}

.fixed-percent {
  position: absolute;
  top: 0;
  /*transform: translateY(-50%);*/
}
.add-override-fixed {
  left: 5px;
}
.add-override-percent {
  left: 100px;
}

.custom-override {
  position: relative;
}

.close-custom-override {
  position: absolute;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: white;
  top: -17px;
  right: -11px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  font-size: 14px;
  color: black;
  /*border: 1px solid rgba(0.5, 0.5, 0.5, 0.1);*/
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.26);

  & > img {
    width: 10px;
    height: 10px;
    opacity: 0.9;
    transform: translate(-0.5px, 0px) rotate(45deg);
  }
}


//
// Top Right
//
.top-right {
  flex: 1;
  justify-content: flex-end;
  & > span {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  @media(max-width: 768px) {
    width: calc(50% - 5px);
    > span {width: calc(100% - 5px);}
  }
  @media(max-width: 520px) {
    width: 100%;
  }
}

.versions-menu {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateX(calc(100% + 10px));
  width: 300px;
  padding-bottom: 20px;

  &::before {
    position: absolute;
    content: ' ';
    height: 20px;
    width: 20px;
    top: 70px;
    background-color: white;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    left: -3px;
  }

  .versions-menu-inner {
    position: relative;
  }
}

.version-select {
  padding: 20px;

  &:nth-child(even) {
    background-color: #F5F5F5;
  }
}

.version-select-title {
  color: #0874D8;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.43px;
  line-height: 15px;
}

.version-item {
  text-transform: uppercase;
}

.version-now {
  background-color: #D9EDFF !important;
  font-weight: 600;
}

#total-sum {
}

.flash-total-sum {
  background-color: #0874D8;
}

.flash-total-sum-2 {
  transition: background-color 0.6s;
}
.no-hours {
  color: grey;
  & > span {
    color: grey;
    & > p {
      color: grey;
    }
  }
  .no-hours-smaller {
    font-size: 19px;
  }
}
.tooltip-no-hours {
  /*position: absolute;*/
  /*right: 5px;*/
  /*bottom: 5px;*/
}
.top-divider {
  width: 2px;
  height: 32px;
  background-color: #D8D8D8;
  margin-top: 7px;
}
.price-range-selector-box {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: space-around
}
.price-range-selector {
  p {
    text-align: center;
    font-size: 10px;
    line-height: 1em;
  }
}
.price-range-label {
  margin-top: 3px;
  margin-bottom: 3px;
}
.triangle-up, .triangle-down {
  color: $grey5;
}
.overrides-item {
  @media(max-width: 768px) {
    display: none;
  }
}
.now {
  white-space: nowrap;
}
.new-override-button {
  width: 175px;
  max-width: 175px;
  min-width: 175px;
  margin-bottom: 0 !important;
}
button:disabled, button[disabled] {
  cursor: not-allowed !important;
  background-color: #aca1f4;
}
</style>
